import styles from "../styles/theme";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TermsOfService() {
  const navigate = useNavigate();

  const heading = { fontSize: 20, fontWeight: "bold", margin: "32px 0 12px", color: "#e8e4dc" };
  const subheading = { fontSize: 16, fontWeight: "bold", margin: "20px 0 8px", color: "#d4d0c8" };
  const para = { fontSize: 14, color: "#9a9490", lineHeight: 1.8, margin: "0 0 12px" };
  const list = { fontSize: 14, color: "#9a9490", lineHeight: 1.8, margin: "0 0 12px", paddingLeft: 24 };

  return (
    <div style={styles.root}>
      <Navbar view="terms" setView={() => navigate("/")} navigate={navigate} />
      <main style={styles.main} data-main-container>
        <div style={{ maxWidth: 720, paddingTop: 32 }}>
          <button style={styles.backBtn} onClick={() => navigate("/")}>{"\u2190"} Back</button>
          <div style={{ background: "#111316", border: "1px solid #1e2022", borderRadius: 12, padding: "36px 40px" }}>
            <h1 style={{ fontSize: 28, fontWeight: "bold", margin: "0 0 8px", letterSpacing: "-0.5px" }}>Terms of Service</h1>
            <p style={{ fontSize: 13, color: "#6a6660", margin: "0 0 28px" }}>Effective Date: May 16, 2026</p>

            <p style={para}>
              Welcome to UXOHire. By accessing or using the UXOHire platform ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Service.
            </p>

            <h2 style={heading}>1. Service Description</h2>
            <p style={para}>
              UXOHire is an online marketplace that connects Unexploded Ordnance (UXO) technicians with employers seeking qualified personnel. The platform enables technicians to create professional profiles showcasing their certifications, experience, and availability, and enables employers to discover, evaluate, and contact qualified technicians for employment opportunities.
            </p>

            <h2 style={heading}>2. Account Types</h2>
            <h3 style={subheading}>2.1 Technician Accounts</h3>
            <p style={para}>
              Technician accounts are free to create and maintain. Technicians may create a profile, list their certifications and experience, indicate their availability, and be discovered by employers through the platform.
            </p>
            <h3 style={subheading}>2.2 Employer Accounts</h3>
            <p style={para}>
              Employer accounts require a paid subscription to access full platform features, including the ability to unlock technician contact information and post job listings.
            </p>

            <h2 style={heading}>3. Subscription Terms</h2>
            <h3 style={subheading}>3.1 Pricing</h3>
            <p style={para}>
              UXOHire offers two employer subscription tiers:
            </p>
            <ul style={list}>
              <li><strong>Starter</strong> — $1,199/month or $11,990/year. Includes 5 active job posts and 10 contact unlocks per billing cycle (unused unlocks roll over, max 15). Email support with response within 2 business days.</li>
              <li><strong>Pro</strong> — $1,999/month or $19,990/year. Includes unlimited job posts and 15 contact unlocks per billing cycle (unused unlocks roll over, max 25). Priority email support with response within 1 business day, plus a monthly account check-in.</li>
            </ul>
            <h3 style={subheading}>3.2 Overage</h3>
            <p style={para}>
              Additional contact unlocks beyond those included in your subscription tier may be available. Overages are charged at the end of each billing cycle. Contact support for details.
            </p>
            <h3 style={subheading}>3.3 Cancellation</h3>
            <p style={para}>
              You may cancel your subscription at any time. Upon cancellation, your subscription will remain active through the end of the current billing period. No prorated refunds will be issued for partial billing periods.
            </p>

            <h2 style={heading}>4. Contact Unlock Terms</h2>
            <p style={para}>
              Contact unlocks are non-refundable once used. By unlocking a technician's contact information, you agree to the following:
            </p>
            <ul style={list}>
              <li>Contact information obtained through unlocks may only be used for legitimate hiring and employment purposes directly related to UXO industry positions.</li>
              <li>You may not use unlocked contact information to build, augment, or contribute to any database, mailing list, contact list, or directory of any kind.</li>
              <li>You may not sell, transfer, license, or otherwise distribute contact information obtained through the platform to any third party.</li>
              <li>Systematic or automated unlocking of contact information ("harvesting") is strictly prohibited.</li>
            </ul>

            <h2 style={heading}>5. User Responsibilities (Technicians)</h2>
            <p style={para}>
              As a technician using UXOHire, you agree to:
            </p>
            <ul style={list}>
              <li>Provide accurate and truthful profile information at all times.</li>
              <li>Maintain current and valid certifications as represented on your profile.</li>
              <li>Truthfully represent your qualifications, field hours, experience, and employment history.</li>
              <li>Promptly update your profile when any information changes, including certification expirations or renewals.</li>
              <li>Not misrepresent your skills, training, or clearance status.</li>
            </ul>

            <h2 style={heading}>6. Document Uploads</h2>
            <p style={para}>
              UXOHire allows technicians to upload professional documents to their profiles. By uploading documents to UXOHire, you acknowledge and agree to the following:
            </p>
            <ul style={list}>
              <li>Employers who unlock your profile may view and download those documents.</li>
              <li>You are responsible for ensuring uploaded documents are accurate and belong to you.</li>
              <li>UXOHire reserves the right to remove documents that violate these Terms.</li>
            </ul>

            <h2 style={heading}>7. Invitation System</h2>
            <p style={para}>
              UXOHire provides an invitation system that allows employers and technicians to connect regarding job opportunities:
            </p>
            <ul style={list}>
              <li>Employers may invite technicians to apply for specific job postings.</li>
              <li>Technicians are not obligated to respond to or accept any invitation.</li>
              <li>Invitations are facilitated through the platform messaging system.</li>
            </ul>

            <h2 style={heading}>8. Job Matching</h2>
            <p style={para}>
              UXOHire provides a job matching feature to help employers evaluate potential candidates:
            </p>
            <ul style={list}>
              <li>UXOHire uses certification and experience data to calculate job match percentages displayed to employer accounts.</li>
              <li>Match percentages are estimates based on self-reported data and should not be the sole basis for hiring decisions.</li>
            </ul>

            <h2 style={heading}>9. Profile Visibility</h2>
            <p style={para}>
              UXOHire provides technicians with controls over their profile visibility:
            </p>
            <ul style={list}>
              <li>Technicians may control whether their profile is visible to other technicians on the platform.</li>
              <li>Profiles remain visible to employer accounts when Open to Work status is enabled, regardless of technician visibility settings.</li>
            </ul>

            <h2 style={heading}>10. Employer Responsibilities</h2>
            <p style={para}>
              As an employer using UXOHire, you agree to:
            </p>
            <ul style={list}>
              <li>Post only legitimate job opportunities with accurate descriptions, requirements, and compensation information.</li>
              <li>Not post discriminatory job listings. All postings must comply with applicable federal, state, and local employment laws, including Title VII of the Civil Rights Act, the Americans with Disabilities Act, and the Age Discrimination in Employment Act.</li>
              <li>Use the platform solely for the purpose of recruiting and hiring qualified UXO technicians.</li>
              <li>Treat all technician information obtained through the platform as confidential.</li>
            </ul>

            <h2 style={heading}>11. Platform Rules</h2>
            <p style={para}>
              All users agree to the following platform rules:
            </p>
            <ul style={list}>
              <li>You may not circumvent, bypass, or attempt to circumvent the contact unlock system through any means, including but not limited to requesting contact information through job postings, profile descriptions, or any other platform feature.</li>
              <li>You may not share contact information obtained through the platform with any third party without the express written consent of the individual whose information was unlocked.</li>
              <li>You may not use the platform for any unlawful purpose or in violation of any applicable law or regulation.</li>
              <li>You may not create multiple accounts to circumvent platform limitations or avoid fees.</li>
              <li>You may not scrape, crawl, or use automated means to access or collect data from the platform.</li>
            </ul>

            <h2 style={heading}>12. Account Termination</h2>
            <p style={para}>
              UXOHire reserves the right to suspend or terminate any account, at our sole discretion, for violation of these Terms or for any conduct that we determine to be harmful to the platform, other users, or third parties. This includes, but is not limited to:
            </p>
            <ul style={list}>
              <li>Providing false or misleading information.</li>
              <li>Violating contact unlock terms or anti-harvesting provisions.</li>
              <li>Posting discriminatory or fraudulent job listings.</li>
              <li>Circumventing the platform's unlock or payment systems.</li>
              <li>Any other violation of these Terms.</li>
            </ul>
            <p style={para}>
              In the event of termination for cause, no refund of subscription fees or unused contact unlocks will be provided.
            </p>

            <h2 style={heading}>13. Limitation of Liability</h2>
            <p style={para}>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, UXOHIRE AND ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND AFFILIATES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, OR GOODWILL, ARISING OUT OF OR IN CONNECTION WITH YOUR ACCESS TO OR USE OF THE SERVICE.
            </p>
            <p style={para}>
              UXOHire does not guarantee the accuracy, completeness, or validity of any information provided by technicians or employers on the platform, including but not limited to certifications, qualifications, field hours, or job posting details. Users are responsible for independently verifying all information before making hiring or employment decisions.
            </p>
            <p style={para}>
              UXOHire is not a party to any employment agreement between technicians and employers and assumes no liability for the outcome of any hiring decision or employment relationship facilitated through the platform.
            </p>
            <p style={para}>
              IN NO EVENT SHALL UXOHIRE'S TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATED TO THE SERVICE EXCEED THE AMOUNT PAID BY YOU TO UXOHIRE IN THE TWELVE (12) MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM.
            </p>

            <h2 style={heading}>14. Disclaimer of Warranties</h2>
            <p style={para}>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. UXOHIRE DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE.
            </p>

            <h2 style={heading}>15. Indemnification</h2>
            <p style={para}>
              You agree to indemnify, defend, and hold harmless UXOHire and its officers, directors, employees, agents, and affiliates from and against any and all claims, liabilities, damages, losses, costs, and expenses (including reasonable attorneys' fees) arising out of or related to your use of the Service, your violation of these Terms, or your violation of any rights of any third party.
            </p>

            <h2 style={heading}>16. Modifications to Terms</h2>
            <p style={para}>
              UXOHire reserves the right to modify these Terms at any time. We will notify users of material changes by posting the updated Terms on the platform and updating the "Effective Date" above. Your continued use of the Service after any such changes constitutes your acceptance of the new Terms.
            </p>

            <h2 style={heading}>17. Governing Law</h2>
            <p style={para}>
              These Terms shall be governed by and construed in accordance with the laws of the State of Texas, without regard to its conflict of law principles. Any disputes arising out of or relating to these Terms or the Service shall be resolved exclusively in the state or federal courts located in the State of Texas, and you consent to the personal jurisdiction of such courts.
            </p>

            <h2 style={heading} id="verification-disclaimer">18. Verification Disclaimer</h2>
            <p style={para}>
              UXOHire's document review process checks that submitted documents appear to meet minimum DDESB TP-18 format requirements and that logbook hours bear a supervisor's attesting signature. UXOHire does not verify the authenticity, legitimacy, or validity of any uploaded documents, does not verify the identity of supervisors or certifying officials, does not audit the accuracy of reported hours, and does not guarantee that any certification was legitimately earned.
            </p>
            <p style={para}>
              Employers are solely responsible for conducting their own due diligence, background checks, reference checks, and independent verification of all candidate credentials prior to making any hiring decisions. UXOHire shall not be held liable for any damages, losses, or claims arising from reliance on platform documentation badges or documented status indicators.
            </p>

            <h2 style={heading}>19. Contact</h2>
            <p style={para}>
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <p style={{ ...para, color: "#d97706" }}>
              support@uxohire.com
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
